import React from 'react';

export default function formFieldsHandler (Component) {
  return class FormFieldsHandler extends Component {

    constructor (props) {
      super(props);
    }

    componentDidMount () {

    }

    _handleDisable(formElems) {
      for( let e = 0; e < formElems.length; e++ ) {
        formElems[e].setAttribute('disabled', 'disabled');
      }
    }

    _handleEnable(formElems) {
      for( let e = 0; e < formElems.length; e++ ) {
        formElems[e].removeAttribute('disabled');
      }
    }

    componentDidUpdate () {
      const { pageState: { inTraffic = true, isAsync = true } = {} } = this.props;

      if (!isAsync) {
        return;
      }

      const dom = this.form;
      if (!dom) {
        return;
      }
      const inputs = dom.querySelectorAll('input:not([data-disabled=true])');
      const textareas = dom.querySelectorAll('textarea:not([data-disabled=true])');
      const selects = dom.querySelectorAll('select:not([data-disabled=true])');
      const buttons = dom.querySelectorAll('button:not([data-disabled=true])');
      const formControls = [inputs, textareas, selects, buttons];

      if (inTraffic) {
        formControls.map(this._handleDisable);
      } else {
        formControls.map(this._handleEnable);
      }
    }

    handleAsyncFormState (ref) {
      this.form = ref;
    }

    render () {
      return (
        <div ref="baseRef">
          <Component {...this.props} handleAsyncFormState={ (ref) => this.handleAsyncFormState(ref) } />
        </div>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/decorators/FormFieldsHandler.js